import Layout from './Layout';
import Link from './Link';

export const components = {
  a: Link,
  wrapper: Layout,
};
